import { StripeDisputeReason } from 'shared/types/graphql';
import { PaymentReportColumnNames, PaymentReportColumnSelectors } from '../enums';
import { IColumnSelection } from '../types';

export const initialDisputesColumnsSelection: IColumnSelection[] = [
  {
    name: PaymentReportColumnNames.Created,
    selector: PaymentReportColumnSelectors.Created,
    sortable: true,
    omit: false,
    width: '155px',
  },
  {
    name: PaymentReportColumnNames.ClientName,
    selector: PaymentReportColumnSelectors.ClientName,
    sortable: false,
    omit: false,
    width: '155px',
  },
  {
    name: PaymentReportColumnNames.DisputeStatus,
    selector: PaymentReportColumnSelectors.DisputeStatus,
    sortable: false,
    omit: false,
    width: '250px',
  },
  {
    name: PaymentReportColumnNames.Manage,
    selector: PaymentReportColumnSelectors.Manage,
    sortable: false,
    omit: false,
    width: '170px',
  },
  {
    name: PaymentReportColumnNames.DisputeReason,
    selector: PaymentReportColumnSelectors.DisputeReason,
    sortable: false,
    omit: false,
    width: '210px',
  },
  {
    name: PaymentReportColumnNames.TransactionType,
    selector: PaymentReportColumnSelectors.TransactionType,
    sortable: false,
    omit: false,
    width: '155px',
  },
  {
    name: PaymentReportColumnNames.PaidAt,
    selector: PaymentReportColumnSelectors.PaidAt,
    sortable: false,
    omit: false,
    width: '155px',
  },
  {
    name: PaymentReportColumnNames.Amount,
    selector: PaymentReportColumnSelectors.Amount,
    sortable: true,
    omit: false,
    right: true,
  },

  {
    name: PaymentReportColumnNames.Actions,
    selector: PaymentReportColumnSelectors.Actions,
    sortable: false,
    omit: false,
  },
];

export const STRIPE_DISPUTE_REASON_MAPPING: Record<StripeDisputeReason, string> = {
  [StripeDisputeReason.BankCannotProcess]: 'Bank Cannot Process',
  [StripeDisputeReason.CheckReturned]: 'Check Returned',
  [StripeDisputeReason.CreditNotProcessed]: 'Credit not Processed',
  [StripeDisputeReason.CustomerInitiated]: 'Customer Initiated',
  [StripeDisputeReason.DebitNotAuthorized]: 'Debit Not Authorized',
  [StripeDisputeReason.Duplicate]: 'Duplicate',
  [StripeDisputeReason.Fraudulent]: 'Fraudulent',
  [StripeDisputeReason.General]: 'General',
  [StripeDisputeReason.IncorrectAccountDetails]: 'Incorrect Account Details',
  [StripeDisputeReason.InsufficientFunds]: 'Insufficient Funds',
  [StripeDisputeReason.ProductNotReceived]: 'Product Not Received',
  [StripeDisputeReason.ProductUnacceptable]: 'Product Unacceptable',
  [StripeDisputeReason.SubscriptionCanceled]: 'Subscription Canceled',
  [StripeDisputeReason.Unknown]: 'Unknown',
  [StripeDisputeReason.Unrecognized]: 'Unrecognized',
};
